import dynamic from "next/dynamic";
import type { ComponentType } from "react";
import type { ActionType } from "@/tools/sanity/schema/elements/link";

const modalRegistry: Record<ActionType, ComponentType> = {
  openBrandOrderModal: dynamic(() => import("@/components/BrandOrderModal"), {
    ssr: false,
  }),
};

export default modalRegistry;
